import React, {useEffect, useState} from 'react';
import {
    AccountStoreSettingDto,
    FileDto,
    FlyerLanguageDto, StoreShelfStylesDto,
} from "../../../../../../../../dtos";
import Draggable from "react-draggable";
import {Box, Button, Grid, Typography} from "@mui/material";
import {PopupHeader} from "../../../../../../../com/popupHeader/popupHeader";
import {makeStyles} from "@mui/styles";
import TextInput from "../../../../../../../../com/textInput/TextInput";
import ColorsSelector from "../../../../../../../../com/colorsSelector2/ColorsSelector";
import LabelFileSelector from "../../../../../../../../com/labelFileSelector/LabelFileSelector";
import {AsyncImageWithLoader} from "../../../../../../../../com/imageWithLoader/imageWithLoader";
import './storeSettingCreateEditPopup.scss'
import {FONT_NAME_ROBOTO, FONTS_ARRAY_FOR_SELECT} from "../../../../../../../../globals";
import ImageLoader from "../../../../../../../../com/imageLoader/ImageLoader";
import {ReactComponent as CameraIcon} from "../../../../../../../../assets/camera_icon.svg";
import {ReactComponent as UploadIcon} from "../../../../../../../../assets/editors/upload_icon.svg";
import StatusPopup, {StatusPopupType} from "../../../../../../../../com/statusPopup/StatusPopup";
import {useTypedSelector} from "../../../../../../../../hooks/useTypeSelector";
import {PageSpinner} from "../../../../../../../com/pagesTab/pagesSpinner/spinner";
import StoreShelfStylesSelect from "../../../../../../../../com/storeShelfStylesSelect/storeShelfStylesSelect";
import FontsSelect from '../../../../../../../../com/fontsSelect/fontsSelect';
import Switch from "react-switch";


const useStyles = makeStyles(() => ({
    storeSettingCreateEditWrapperContainer: {
        position: "absolute",
        zIndex: 1061,
        top: 0,
        left: 0,
        height: "100vh",
        width: "100vw",
        backgroundColor: "#00000080",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    storeSettingCreateEditPopup: {
        width: `564px`,
        backgroundColor: `#ffffff`,
        maxHeight: `98vh`,
        display: `flex`,
        flexFlow: `column`,
        "& .MuiInputBase-input": {
            padding: `5px`,
            height: `20px`,
        },
    },
    storeSettingCreateEditContentWrapper: {
        padding: "20px",
    },
    saveBtn: {
        "&.MuiButton-root": {
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "22px",
            /* or 157% */

            textAlign: "center",

            color: "#FFFFFF",
            width: "100%",
            borderRadius: "2px",

            background: "linear-gradient(135.47deg, #DD5A01 3.9%, #F0CA21 100%)",

            paddingTop: "8px",
            paddingBottom: "8px",
            "&.Mui-disabled": {
                opacity: "0.5",
                color: "#FFFFFF",

            }
        },
    }
}));

interface LanguageDto {
    value?: string,
    label?: string,
    language?: FlyerLanguageDto
}

interface CurrencyDto {
    value?: string,
    label?: string,
}

interface Props {
    show: boolean;
    onHide: VoidFunction;
    storeSetting: AccountStoreSettingDto;
    onSave: (storeSettingData: AccountStoreSettingDto, backgroundFile: FileDto | null, logoFile: FileDto | null) => void;
}

const StoreSettingCreateEditPopup: React.FC<Props> = ({
                                                          show,
                                                          onHide,
                                                          storeSetting,
                                                          onSave
                                                      }) => {
    const customStylesForSelect = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            height: "48px",
            border: "1px solid #ced4da",
            borderLeft: `1px solid #ced4da`,
            borderRadius: `5px`,
            fontWeight: "normal",
            textAlign: "start",
            lineHeight: "1",
            minHeight: `auto`,
            cursor: "pointer",
            ":hover": {
                border: "1px solid #ced4da",
                borderLeft: `1px solid #ced4da`,
            },
        }),

        singleValue: (base: any) => ({
            ...base,
            // fontSize: `16px`,
            lineHeight: `24px`
            // height: "16px",
        }),
        valueContainer: (base: any) => ({
            ...base,
            height: "48px",
            padding: "2px 8px",
            fontSize: "16px",
        }),
        input: (base: any) => ({
            ...base,
            height: "48px",
        }),
        menuList: (base: any) => ({
            ...base,
            fontWeight: "normal",
            padding: "2px 0"

        }),
        menu: (base: any) => ({
            ...base,
            zIndex: `2`,
            margin: "4px 0"
        })
    };

    const classes = useStyles();
    const flyersState = useTypedSelector((state) => state.flyers);
    const accountStoreSettings = useTypedSelector((state) => state.accountStoreSettings);
    const storeShelfStyles: StoreShelfStylesDto = useTypedSelector((state) => state.storeShelfStyles)

    const [themeName, setThemeName] = useState('');
    const [color, setColor] = useState('#ffff00');
    const [isDisplayPrices, setIsDisplayPrices] = useState<boolean>(true);
    const [isDisplayPromos, setIsDisplayPromos] = useState<boolean>(true);
    const [backgroundColor, setBackgroundColor] = useState<string | null>('#ffff00')

    const [logo, setLogo] = useState<FileDto | null>(null)
    const [backgroundImg, setBackgroundImg] = useState<FileDto | null>(null);
    const [logoUrl, setLogoUrl] = useState<string | null>(null);
    const [backgroundUrl, setBackgroundUrl] = useState<string | null>(null);
    const [language, setLanguage] = useState<LanguageDto>();

    const [isImageUrlSelected, setImageUrlMain] = useState<boolean>(false);

    const [fontValue, setFontValue] = useState(FONT_NAME_ROBOTO);
    const [fontLabel, setFontLabel] = useState(FONT_NAME_ROBOTO);

    const [shelfStyleId, setShelfStyleId] = useState<number>(storeSetting.storeShelfStyleId ? storeSetting.storeShelfStyleId : storeShelfStyles.storeShelfStyles && storeShelfStyles.storeShelfStyles[0] ? storeShelfStyles.storeShelfStyles[0].id : 0);


    const [infoPopupSubTitle, setInfoPopupSubTitle] = useState('');
    const [showInfoPopup, setShowInfoPopup] = useState(false);
    const widthForLabels = "col-sm-4";
    const widthForInputs = "col-sm-8";

    const languages = flyersState?.languageCultures?.map((lang: FlyerLanguageDto) => {
        return {
            value: lang.code,
            label: lang.caption,
            language: {
                ...lang
            }
        }
    });


    useEffect(() => {
        const currentLang = getLanguage(storeSetting.languageCultureId ? storeSetting.languageCultureId : 0, languages ? languages : []);
        setLanguage(currentLang);
        setThemeName(storeSetting.caption ? storeSetting.caption : '')
        setColor(storeSetting.primaryColorRgb ? storeSetting.primaryColorRgb : '#0000FF')
        setBackgroundColor(storeSetting.backgroundColorRgb ? storeSetting.backgroundColorRgb : '#ffffff')
        setIsDisplayPrices(storeSetting.isDisplayPrices ? storeSetting.isDisplayPrices : false);
        setIsDisplayPromos(storeSetting.isDisplayPromos ? storeSetting.isDisplayPromos : false);
        let fileDto: FileDto = {
            file: null,
            label: storeSetting.logo ? storeSetting.logo : null
        }
        setLogo(fileDto)

        const backgroundDto: FileDto = {
            file: null,
            label: storeSetting.backgroundImage ? storeSetting.backgroundImage : null
        }
        setBackgroundImg(backgroundDto);
        setLogoUrl(storeSetting.logoUrl ? storeSetting.logoUrl : '');
        setBackgroundUrl(storeSetting.backgroundImageUrl ? storeSetting.backgroundImageUrl : ``);
        setImageUrlMain(!Boolean(storeSetting.backgroundColorRgb) && Boolean(storeSetting.backgroundImageUrl));

        setFontValue(storeSetting.font ? storeSetting.font : FONT_NAME_ROBOTO);
        if (storeSetting.font === 'OpenSans') {
            setFontLabel('Open Sans')
        } else if (storeSetting.font === 'AlmoniTzar') {
            setFontLabel('Almoni Tzar (Hebrew)')
        } else if (storeSetting.font === 'OpenSansHeb') {
            setFontLabel('Open Sans (Hebrew)')
        } else {
            setFontLabel(storeSetting.font ? storeSetting.font : FONT_NAME_ROBOTO);
        }

    }, [storeSetting]);


    useEffect(() => {
        if (accountStoreSettings.type === "SAVE_ACCOUNT_STORE_SETTING_SUCCESS") {
            onHide();
        }

    }, [accountStoreSettings.type])

    const onColorSwatchChange = (hexColor: string) => {
        setColor(hexColor);
    }

    const onBackgroundSwatchChange = (hexColor: string) => {
        setBackgroundColor(hexColor);
        setImageUrlMain(false);
    }

    const onFontSelectorChange = (value: string) => {
        setFontValue(value);
        const selectedFont = FONTS_ARRAY_FOR_SELECT.find((fontInArray) => {
           if(fontInArray.value === value){
               return fontInArray
           }
        });
        if(selectedFont){
            setFontLabel(selectedFont.label);
        }
    }

    const onChangeShelfStyle = (value: number) => {
        setShelfStyleId(value);
    }

    const toggleShowPrices = () => {
        setIsDisplayPrices(!isDisplayPrices);
    }

    const toggleShowPromos = () => {
        setIsDisplayPromos(!isDisplayPromos);
    }

    const onUploadLogoFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];

        let imageLoader = new ImageLoader();
        let imageDimentions = await imageLoader.loadImageDimensions(file);
        if (imageDimentions.width > 300 || imageDimentions.height > 200) {
            setInfoPopupSubTitle('Logo must be smaller than 300x200px.')
            setShowInfoPopup(true)
            return;
        }

        const newLogo: FileDto = {
            label: file.name,
            file: file
        };

        setLogo(newLogo);
        setLogoUrl(URL.createObjectURL(file));
    }

    const onUploadBackgroundImage = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files![0];
        const newBackground: FileDto = {
            label: file.name,
            file: file
        };

        setBackgroundImg(newBackground);
        setBackgroundUrl(URL.createObjectURL(file));
        setImageUrlMain(true);
    }

    const handleSave = () => {
        const data: AccountStoreSettingDto = {
            ...storeSetting,
            languageCultureId: language?.language?.id ? language?.language?.id : 1,
            id: storeSetting.id ? storeSetting.id : 0,
            caption: themeName,
            primaryColorRgb: color,
            logo: logo?.label!,
            logoUrl: logoUrl ? logoUrl! : '',
            font: fontValue,
            backgroundColorRgb: !isImageUrlSelected ? backgroundColor : ``,
            backgroundImage: isImageUrlSelected ? backgroundImg?.label : ``,
            backgroundImageUrl: isImageUrlSelected && backgroundUrl ? backgroundUrl : '',
            storeShelfStyleId: shelfStyleId,
            isDisplayPrices,
            isDisplayPromos
        }
        onSave(data, backgroundImg ? backgroundImg : null, logo ? logo! : null);
    }

    const getLanguage = (
        langId: number,
        languages: LanguageDto[] | []
    ): LanguageDto => {
        const langFromLangArray = languages.find((lang: LanguageDto) => lang.language?.id === langId);

        if (langId !== 0 && langFromLangArray) {
            return {
                ...langFromLangArray
            }
        } else {
            return {
                value: "en-US",
                label: `English (US)`,
                language: {
                    caption: "English (US)",
                    captionNative: "English (US)",
                    code: "en-US",
                    currencyAbbrv: "USD",
                    currencySymbol: "$",
                    dir: "LTR",
                    id: 1
                }
            }
        }
    };

    const changeLang = (item: any) => {
        setLanguage(item);
        console.log(`Option selected:`, item);
    };


    const setting = {
        modalName: "error"
    }

    return (
        <Box
            className={classes.storeSettingCreateEditWrapperContainer}
        >
            <Draggable
                bounds="body"
                handle={`.draggable_header_store_edit_create_settings_popup`}
                defaultPosition={{x: 0, y: 0}}
            >
                <Box className={`${classes.storeSettingCreateEditPopup} store_setting`}>
                    {accountStoreSettings.loading &&
                        <Box
                            sx={{
                                position: "absolute",
                                zIndex: "2",
                                height: "100%",
                                width: "100%",
                                backgroundColor: "#e4e4e4a1",
                                display: `flex`,
                                alignItems: `center`,
                                justifyContent: `center`,
                            }}
                        >
                            <PageSpinner/>
                        </Box>
                    }

                    <PopupHeader
                        headerCaption={storeSetting.id ? "Edit Store Setting" : "Create Store Setting"}
                        onClose={onHide}
                        bg={"linear-gradient(89.41deg, #0198D2 0%, #3540A8 100%)"}
                        jc={"flex-start"}
                        classForHeader={"draggable_header_store_edit_create_settings_popup"}
                    />
                    <Box className="container">

                        <div className="gui_theme_container">
                            <TextInput
                                label="Store Setting Name:"
                                type="text"
                                value={themeName}
                                onChange={e => {
                                    let value = e.target.value;
                                    setThemeName(value)
                                }}
                                errorMessage={''}
                                verticalMode={false}
                                horizontalLabelCol={widthForLabels}
                                horizontalInputCol={widthForInputs}
                                maxLength={30}
                                bordersColor={"#d1d7db"}
                                withoutErrorMessage={true}
                            />
                        </div>

                        {/*<div className="row">*/}
                        {/*    <div className={widthForLabels} style={{*/}
                        {/*        display: `flex`,*/}
                        {/*        alignItems: `center`*/}
                        {/*    }}>*/}
                        {/*        <label>Language:</label>*/}
                        {/*    </div>*/}
                        {/*    <div className={widthForInputs}>*/}
                        {/*        <Select*/}
                        {/*            styles={customStylesForSelect}*/}
                        {/*            classNamePrefix="languagesSelect"*/}
                        {/*            className={`select`}*/}
                        {/*            value={language}*/}
                        {/*            onChange={changeLang}*/}
                        {/*            getOptionValue={(option) => option.value!}*/}
                        {/*            getOptionLabel={(option) => option.label!}*/}
                        {/*            options={languages}*/}
                        {/*            isSearchable={false}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="gui_theme_container">*/}
                        {/*    <TextInput*/}
                        {/*        label="Currency:"*/}
                        {/*        type="text"*/}
                        {/*        value={language?.language?.currencySymbol}*/}
                        {/*        onChange={() => {}}*/}
                        {/*        errorMessage={''}*/}
                        {/*        verticalMode={false}*/}
                        {/*        horizontalLabelCol={widthForLabels}*/}
                        {/*        horizontalInputCol={widthForInputs}*/}
                        {/*        maxLength={30}*/}
                        {/*        withoutErrorMessage={true}*/}
                        {/*        readOnly={true}*/}
                        {/*        bordersColor={"transparent"}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        <div className="upload_logo_container row">
                            <div className={widthForLabels} style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label htmlFor="" style={{
                                    margin: 0
                                }}>
                                    Store Logo:
                                </label>
                            </div>
                            <div className={widthForInputs}>
                                <Grid container sx={{height: `100%`}} alignItems={`center`} columnSpacing={1}>
                                    {
                                        !logo?.label &&
                                        <Grid item xs>
                                            <Box sx={{
                                                display: `flex`,
                                                alignItems: `center`,
                                                columnGap: "20px"
                                            }}>
                                                <Box sx={{
                                                    maxWidth: `50px`,
                                                    maxHeight: `50px`,
                                                    minWidth: `50px`,
                                                    minHeight: `50px`,
                                                    border: `1px solid #d1d7db`,
                                                    borderRadius: `5px`,
                                                    display: `flex`,
                                                    alignItems: `center`
                                                }}>
                                                    <CameraIcon style={{
                                                        maxWidth: `inherit`,
                                                        maxHeight: `inherit`,
                                                        width: `100%`,
                                                        height: `100%`,
                                                        padding: `2px`,
                                                    }}/>
                                                </Box>
                                                <Typography fontSize={`12px`} mx={`20px`}>
                                                    No Image
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    }
                                    {
                                        logoUrl &&
                                        <Grid item xs>
                                            <Box sx={{
                                                display: `flex`,
                                                justifyContent: `center`,
                                                padding: `4px`,
                                                backgroundColor: color
                                            }}>
                                                <img src={logoUrl} alt="img" style={{
                                                    maxWidth: `100%`,
                                                    maxHeight: `50px`
                                                }}/>
                                            </Box>

                                        </Grid>
                                    }
                                    <Grid item xs={2}>
                                        <Box sx={{
                                            display: `flex`, alignItems: `center`,
                                            justifyContent: `center`,
                                        }}
                                             title={`Upload Image`}
                                        >
                                            <LabelFileSelector
                                                accept={".png, .jpg"}
                                                fileId="upload_logo"
                                                onChange={onUploadLogoFileChange}
                                            >
                                                <UploadIcon/>
                                            </LabelFileSelector>

                                        </Box>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        <div className="row">
                            <div className={widthForLabels} style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Store Color:</label>
                            </div>
                            <div className={widthForInputs}>
                                <ColorsSelector
                                    currentSelectedColor={color}
                                    onColorSwatchChange={onColorSwatchChange}
                                    type={`color`}
                                    backgroundImageURL={backgroundUrl}
                                    isImageUrlSelected={isImageUrlSelected}
                                />
                            </div>
                        </div>

                        <div className="row bgImageAndColorWrapper">
                            <div className={widthForLabels} style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Background:</label>
                            </div>
                            <div className={widthForInputs}>
                                <ColorsSelector
                                    currentSelectedColor={backgroundColor}
                                    onColorSwatchChange={onBackgroundSwatchChange}
                                    type={`backgroundColor`}
                                    backgroundImageURL={backgroundUrl}
                                    isImageUrlSelected={isImageUrlSelected}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className={widthForLabels}>
                            </div>
                            <div className={widthForInputs}>
                                <Grid container columnSpacing={1}>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs>
                                        <Grid container sx={{height: `100%`}} alignItems={`center`}
                                              columnSpacing={`2px`}>
                                            <Grid item xs>
                                                <Box sx={{
                                                    display: `flex`
                                                }}>
                                                    <Box sx={{
                                                        maxWidth: `50px`,
                                                        maxHeight: `50px`,
                                                        minWidth: `50px`,
                                                        minHeight: `50px`,
                                                        border: `1px solid #d1d7db`,
                                                        borderRadius: `5px`
                                                    }}>
                                                        <AsyncImageWithLoader
                                                            src={backgroundUrl && isImageUrlSelected ? backgroundUrl : ``}
                                                            notUploadIcon={(
                                                                <CameraIcon/>
                                                            )}
                                                        />
                                                    </Box>
                                                    <Box sx={{display: `flex`, alignItems: `center`, margin: `0 20px`}}>
                                                        {backgroundImg?.label && isImageUrlSelected
                                                            ? <Typography>
                                                                {backgroundImg.label}
                                                            </Typography>
                                                            : <Typography fontSize={`12px`}>No Image</Typography>

                                                        }
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Box
                                                    sx={{
                                                        display: `flex`, alignItems: `center`,
                                                        justifyContent: `center`,
                                                    }}
                                                    title={`Upload Image`}
                                                >
                                                    <LabelFileSelector
                                                        accept={".png, .jpg"}
                                                        fileId="upload_background"
                                                        onChange={onUploadBackgroundImage}
                                                    >
                                                        <UploadIcon/>
                                                    </LabelFileSelector>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        <div className="row flyer_languages_container">
                            <div className={widthForLabels}>
                                <label>Font:</label>
                            </div>
                            <div className={`${widthForInputs} dropdown`}>
                                <FontsSelect
                                    fontName={{value: fontValue, label: fontLabel}}
                                    onChange={onFontSelectorChange}
                                />
                                {/*<FontSelector*/}
                                {/*    fontLabel={{value: fontLabel, label: fontLabel}}*/}
                                {/*    onChange={onFontSelectorChange}*/}
                                {/*    horizontalColSize="col-sm-7"*/}
                                {/*    position={"absolute"}*/}
                                {/*/>*/}
                            </div>
                        </div>
                        <div className="row">
                            <div className={widthForLabels} style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Shelves Style:</label>
                            </div>
                            <div className={widthForInputs}>
                                <StoreShelfStylesSelect onChange={onChangeShelfStyle} shelfStyleId={shelfStyleId}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className={widthForLabels} style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Show Prices:</label>
                            </div>
                            <div className={widthForInputs}
                                style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <Switch
                                    onChange={toggleShowPrices}
                                    checked={isDisplayPrices}
                                    className="react-switch"
                                    height={24}
                                    width={54}
                                    handleDiameter={20}
                                    onColor="#2A70BA"
                                    onHandleColor="#ffffff"
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className={widthForLabels} style={{
                                display: `flex`,
                                alignItems: `center`
                            }}>
                                <label>Show Promos:</label>
                            </div>
                            <div className={widthForInputs}
                                style={{
                                    display: "flex",
                                    alignItems: "center"
                                }}
                            >
                                <Switch
                                    onChange={toggleShowPromos}
                                    checked={isDisplayPromos}
                                    className="react-switch"
                                    height={24}
                                    width={54}
                                    handleDiameter={20}
                                    onColor="#2A70BA"
                                    onHandleColor="#ffffff"
                                />
                            </div>
                        </div>


                        <div className="save_button_container row">
                            <div className={widthForLabels}>

                            </div>
                            <div className={widthForInputs}>
                                <Button disabled={!Boolean(themeName)} className={classes.saveBtn} onClick={handleSave}>Save</Button>
                            </div>
                        </div>

                    </Box>
                    {/*<StoreSettingPopupContent/>*/}
                </Box>
            </Draggable>
            <StatusPopup
                settings={setting}
                type={StatusPopupType.INFO}
                title={'INFO'}
                subTitle={infoPopupSubTitle}
                messages={[]}
                show={showInfoPopup}
                handleClose={() => setShowInfoPopup(false)}
            />
        </Box>
    )
}

export default StoreSettingCreateEditPopup;